import _ from 'lodash';
import { isEmptyVal } from '@/utils';
import {
  getPartnerRefer,
  getTrackingPlanNames,
} from '@/views/config/partner-refer/helper/utils';
import {
  checkEligibleForPartner,
  checkPartnerReferWithZmCoupon,
  getEligiblePlanCodeListForPartner,
} from '@/views/config/partner-refer/helper/validator';
import { logger } from '@/utils/log';
import { couponFetchStatus } from '@/views/config/coupon/helper/constant';

const state = {};

const getters = {
  /**
   * @description partner refer meta information
   * @return {PartnerReferBean}
   */
  partnerRefer: () => getPartnerRefer(),
  // eligible plan code for partner refer code
  eligiblePlanCodeListForPartner: () => getEligiblePlanCodeListForPartner(),
  // ineligible error object for partner refer code
  inEligibleErrorObjectForPartner: (state, getters) => checkEligibleForPartner(getters.eligiblePlanCodeListForPartner),
  partnerCheckLoading: (state, getters) => {
    const partner = getPartnerRefer();

    if (partner.couponCode && partner.rules.validateByCoupon) {
      return getters.verifyCouponStatus === couponFetchStatus.pending;
    }

    return false;
  },
  // Whether the partner refer is validated
  isEligibleForPartner: (state, getters) => isEmptyVal(getters.inEligibleErrorObjectForPartner),
  // show ineligible partner refer message
  showInEligibleMsg: (state, getters) => !getters.eligiblePartnerReferOffer,
  eligiblePartnerReferOffer: (state, getters) => {
    // not meet partner refer check rules
    if (!getters.isEligibleForPartner) {
      return false;
    }

    // partner refer check valid, next check with coupon case
    const checkWithZmCouponResult = checkPartnerReferWithZmCoupon(getters.couponState);

    if (getters.isEligibleForPartner && !checkWithZmCouponResult) {
      logger.error("partner refer not allow use zoom coupon");
      return false;
    }

    return true;
  },
  isFromPartnerRefer: (state, getters) => isEmptyVal(getters.partnerRefer) === false,
  partnerReferProductNames: (state, getters) => {
    /** @type {PartnerReferBean} */
    const partnerRefer = getters.partnerRefer;
    let planCodeList = [];

    if (getters.eligiblePlanCodeListForPartner?.length) {
      planCodeList = getters.eligiblePlanCodeListForPartner;
    } else {
      const eligiblePlanList = partnerRefer.rules?.eligiblePlanList;
      const needPlanNameList = isEmptyVal(eligiblePlanList) ? _.keys(getters.getSelectedPlansWithQuantityMap) : eligiblePlanList;

      planCodeList = _.chain(needPlanNameList)
        .flatten()
        .uniq()
        .value();
    }

    return getTrackingPlanNames(planCodeList, getters.groupByPlanCodePlanMap);
  },
  promoExternalProduct: (state, getters) => {
    return _.find(getters.planMapFlat, (p) => {
      return p?.externalProduct && _.includes(getters.partnerRefer?.preloadPlan, p.plan_code);
    });
  },
};

const mutations = {};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
